import * as React from "react";
import Button from "../button";

import styles from "./styles.module.css";

interface IProps {
  status: number;
  description: React.ReactNode;
  action: () => void;
  actionText: string;
}

export default function ErrorPage({
  status,
  description,
  action,
  actionText
}: IProps) {
  return (
    <div className={styles.errorPage}>
      <div className={styles.title}>{status}</div>
      <div className={styles.title}>Oops.</div>
      <div className={styles.description}>{description}</div>
      <div className={styles.buttons}>
        <Button className={styles.submitButton} onClick={action}>
          {actionText}
        </Button>
      </div>
    </div>
  );
}
